export default "__VITE_ASSET__BX2GF5yj__"